import { useEffect, useState } from "react";
import PointBadgesHeader from "./PointBadgesHeader";
import PointBadgesSortHeader from "./PointBadgesSortHeader";
import PointBadgesList from "./PointBadgesList";
import { badgesTableData } from "../../data/order/badgesTableData";
import { useMilesPoints } from "../../hooks/useMilesPoints";
import CommonPaginationSection from "../common/CommonPaginationSection";

function PointsBadgesSection() {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const { getBadges } = useMilesPoints();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState({
    orderBy: "createdAt",
    order: "asc",
  });

  const loadData = () => {
    getBadges({
      setLoading,
      page: pagination.page,
      limit: pagination.perPage,
      callback: (rewards, total) => {
        setOgData(rewards);
        setOrders(rewards.map((reward) => badgesTableData(reward)));
        setPagination((prev) => ({ ...prev, total }));
      },
      filter,
      sort,
    });
  };

  useEffect(() => {
    loadData();
  }, [filter, pagination.page, pagination.perPage, sort]);

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col w-full">
        <PointBadgesHeader
          value={filter}
          onFilterChange={(value) => setFilter(value)}
          callback={(badge) => {
            setOgData([badge, ...ogData]);
            setOrders([badgesTableData(badge), ...orders]);
          }}
        />
        <PointBadgesSortHeader
          onSortChange={setSort}
          sortField={sort.orderBy}
          sortType={sort.order}
        />
        <PointBadgesList
          loading={loading}
          ogData={ogData}
          orders={orders}
          callback={(badge) => {
            const updatedBadges = ogData.map((og) =>
              og._id === badge._id ? badge : og
            );
            setOgData(updatedBadges);
            setOrders(updatedBadges.map((badge) => badgesTableData(badge)));
          }}
          onDelete={(badge) => {
            const updatedBadges = ogData.filter((og) => og._id !== badge._id);
            setOgData(updatedBadges);
            setOrders(updatedBadges.map((badge) => badgesTableData(badge)));
          }}
        />
        <div className="w-full mt-2">
          <CommonPaginationSection
            perPage={pagination.perPage}
            total={pagination.total}
            page={pagination.page}
            callback={(pg, perPage) =>
              setPagination({ ...pagination, page: pg, perPage })
            }
          />
        </div>
      </div>
    </div>
  );
}

export default PointsBadgesSection;
